export { default as GDMFeedbackModalTypeIcon } from './GDMFeedbackModalTypeIcon';

export type {
  GDMFeedbackModalTypeIconProps,
  GDMFeedbackModalTypeIcons,
  GDMFeedbackModalTypeIconComponent,
} from './GDMFeedbackModalTypeIcon.type';
